<template>
  <AppToggleDropdown
    trigger-classes="color-inherit"
    dropdown-classes="table-actions-dropdown"
    extra-classes="app-toggle-dropdown-header"
  >
    <template #trigger>
      <span class="clickable hover-visible-container">
        {{ header }}
        <i class="hi-edit hover-visible text-blue ml-10" />
      </span>
    </template>
    <ReportShowMemberInfoColumnToggleFields
      v-if="displayInfoFields"
      list-classes="pl-0 list-style-none"
    />
    <ReportShowMemberEmploymentColumnToggleFields
      v-if="displayEmploymentFields"
      list-classes="pl-0 list-style-none"
    />
  </AppToggleDropdown>
</template>

<script>
import ReportShowMemberInfoColumnToggleFields from '~/components/reports/ReportShowMemberInfoColumnToggleFields.vue';
import ReportShowMemberEmploymentColumnToggleFields from '~/components/reports/ReportShowMemberEmploymentColumnToggleFields.vue';

export default {
  name: 'ReportMemberFieldsColumnHeader',
  components: { ReportShowMemberInfoColumnToggleFields, ReportShowMemberEmploymentColumnToggleFields },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['info', 'employment'].includes(value),
    },
  },
  computed: {
    displayInfoFields() {
      return this.type === 'info';
    },
    displayEmploymentFields() {
      return this.type === 'employment';
    },
    header() {
      return this.displayInfoFields ? 'Info' : 'Employment';
    },
  },
};
</script>
